module.exports = __webpack_public_path__ + "static/media/shopify10.1910b39e.png";